// Decorators -
/**  @type {import('react-slick').Settings} */
export const settings = {
  pauseOnDotsHover: true,
  dots: true,
  infinite: true,
  slidesToShow: 1,
  autoplay: true,
  arrows: false,
  autoplaySpeed: 6000,
  pauseOnHover: true,
  cssEase: 'linear',
  slidesPerRow: 1,
  swipe: true
}
